import React,{useContext} from 'react';
import { Row } from '../../../components';
import styles from './styles.module.css';
import * as Icon from '../../../components/Icons';
import { LanguageContext } from '../../../context/Languages/LanguageProvider';
import hotel from './hotel1.jpg';
import { Col } from 'react-flexbox-grid';

const Summary = () => {
  const { i18n } = useContext(LanguageContext);

  return (
      <div>
        <div className={styles.selectedHotel}>
          <Row>
            <Col lg={12} xs={12}>
                <img src={hotel} width={"100%"} alt={"hotelImg"}/>
            </Col>
            <Col lg={12} xs={12}>
              <h1 className={styles.hotelName}>Coco Bodu Hithi</h1>
              <Row>
                <Col lg={5} xs={5}>
                  <div className={styles.stars}>
                      <Icon.Star/>
                      <Icon.Star/>
                      <Icon.Star/>
                      <Icon.StarO/>
                      <Icon.StarO/>
                  </div>
                </Col>
                <Col lg={7} xs={7}>
                  <div className={styles.reviewScore}>9.6</div>
                </Col>
              </Row>
           
              <div className={styles.hotelAddress}>
                <Icon.Pin/>&nbsp;

                K. Boduhithi, North Male Atoll, Maldives Islands, Maldives 20160
              </div>
            </Col>
          </Row>
        </div>
        <div className={styles.bookingDetails}>
            <Row>
              <div className={styles.cardHeader}>
                {i18n.yourBookingDetails}
              </div>
            </Row>
            <div className={styles.details}>
              <Row>
                <Col lg={6} xs={6}>
                  <h3>{i18n.checkIn}</h3>
                  <p>Fri 23 Oct 2020</p>
                  <small>From 14:00</small>
                </Col>
                <Col lg={6} xs={6}>
                  <h3>{i18n.checkOut}</h3>
                  <p>Fri 23 Oct 2020</p>
                  <small>To 14:00</small>
                </Col>
              </Row>
              <Row>
                <Col lg={12} xs={12} style={{marginTop:"10px"}}>
                  <h3>{i18n.totalLength}</h3>
                  <p>5{i18n.nigth}</p>
                  <a href="/#">{i18n.travellingDiffrerent}</a>
                </Col>
              </Row>
              <hr/>
              <Row>
                <Col lg={12} xs={12} style={{marginTop:"10px"}}>
                  <h3>{i18n.yourSelected}</h3>
                  <p>Island villa with private pool</p>
                  <a href="/#">{i18n.changeYourSelection}</a>
                </Col>
              </Row>
            </div>
        </div>
        <div className={styles.priceDetails}>
            <Row>
              <div className={styles.priceCardHeader}>
                <Row>
                  <Col lg={6} xs={6}>
                  <h5>{i18n.price}</h5>
                  <span>{i18n.yourCurrency}</span>
                  </Col>
                  <Col lg={6} xs={6}>
                    <h4>Sar 18,862 *</h4>
                  </Col>
                </Row>
              </div>
            </Row>
            <Row>
              <div className={styles.priceCardHeader}>
                <Row>
                  <Col lg={7} xs={7}>
                  <h5>{i18n.propertyCurrency}</h5>
                  <span>{i18n.in} USD</span>
                  <div className={styles.summaryFor}>(for 5 nigths & all guests)</div>
                  </Col>
                  <Col lg={5} xs={5}>
                    <h4>US 2.387.25</h4>
                  </Col>
                </Row>
              </div>
            </Row>
            <div className={styles.details}>
              <h3>{i18n.additionalCharges}</h3>
              <Row>
                <Col lg={8} xs={8}>
                  <p>{i18n.tax}</p>
                  <p>{i18n.environmentFee}</p>
                  <small>
                    TL 47.42 x 2 guests x 5 nights
                  </small>
                </Col>
                <Col lg={4} xs={4}>
                  <p className={styles.tax}>TL 4316</p>
                  <p className={styles.environmentFee}>TL 474</p>
                </Col>
              </Row>
              <hr/>
              <Row>
                <Col lg={12} xs={12} style={{marginTop:"10px"}}>
                  <p dangerouslySetInnerHTML={{__html:i18n.paymentText}}></p>
                </Col>
              </Row>
            </div>
        </div>
      </div>  
  );
};

export default Summary;
